import { render, staticRenderFns } from "./factoryHome.vue?vue&type=template&id=4efb2b16&scoped=true&"
import script from "./factoryHome.vue?vue&type=script&lang=js&"
export * from "./factoryHome.vue?vue&type=script&lang=js&"
import style0 from "./factoryHome.vue?vue&type=style&index=0&id=4efb2b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb2b16",
  null
  
)

export default component.exports